// function InitialPrompt({ twoFilter }) {
//   return (
//     <div className="text-center align-items-center mt-4">
//       <img
//         src="./choosefirst.png"
//         alt="choose first"
//         style={{ height: "200px", width: "200px" }}
//       />
//       {twoFilter ? (
//         <h4 className="mt-4 fw-semibold text-muted text-center">
//           👋 To get started, please select a{" "}
//           <span className="text-success">date range</span> and{" "}
//           <span className="text-success">store</span> above.
//         </h4>
//       ) : (
//         <h4 className="mt-4 fw-semibold text-muted text-center">
//           👋 To get started, please select a{" "}
//           <span className="text-success">store</span>,{" "}
//           <span className="text-success">month</span> and{" "}
//           <span className="text-success">year</span> above.
//         </h4>
//       )}
//     </div>
//   );
// }

// export default InitialPrompt;

function InitialPrompt({ twoFilter }) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        minHeight: "400px",
        padding: "60px 20px",
        background: "linear-gradient(180deg, #f8fafb 0%, #ffffff 100%)",
        borderRadius: "20px",
        margin: "20px",
      }}
    >
      {/* Icon Container */}
      <div
        style={{
          marginBottom: "28px",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #83c14a, #6fad3e)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 20px 40px rgba(131, 193, 74, 0.3)",
            position: "relative",
          }}
        >
          <img
            src="./choosefirst.png"
            alt="choose first"
            style={{
              height: "70px",
              width: "70px",
              filter: "brightness(0) invert(1)",
            }}
          />
        </div>
      </div>

      {/* Title */}
      <h2
        style={{
          fontSize: "32px",
          fontWeight: "800",
          color: "#0f172a",
          marginBottom: "16px",
          textAlign: "center",
          letterSpacing: "-0.5px",
        }}
      >
        Let's Begin
      </h2>

      {/* Description */}
      <div
        style={{
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          padding: "20px 32px",
          maxWidth: "520px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
        }}
      >
        {twoFilter ? (
          <p
            className="m-0"
            style={{
              fontSize: "15px",
              fontWeight: "500",
              color: "#475569",
              textAlign: "center",
              lineHeight: "1.7",
            }}
          >
            Select{" "}
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "2px 10px",
                background: "#83c14a",
                color: "#ffffff",
                borderRadius: "6px",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              <i className="bi bi-calendar-range"></i>
              Date Range
            </span>{" "}
            and{" "}
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "2px 10px",
                background: "#83c14a",
                color: "#ffffff",
                borderRadius: "6px",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              <i className="bi bi-shop"></i>
              Store
            </span>{" "}
            to view your analytics
          </p>
        ) : (
          <p
            className="m-0"
            style={{
              fontSize: "15px",
              fontWeight: "500",
              color: "#475569",
              textAlign: "center",
              lineHeight: "1.7",
            }}
          >
            Select{" "}
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "2px 10px",
                background: "#83c14a",
                color: "#ffffff",
                borderRadius: "6px",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              <i className="bi bi-shop"></i>
              Store
            </span>
            ,{" "}
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "2px 10px",
                background: "#83c14a",
                color: "#ffffff",
                borderRadius: "6px",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              <i className="bi bi-calendar3"></i>
              Month
            </span>{" "}
            and{" "}
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "2px 10px",
                background: "#83c14a",
                color: "#ffffff",
                borderRadius: "6px",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              <i className="bi bi-calendar-check"></i>
              Year
            </span>{" "}
            to view your analytics
          </p>
        )}
      </div>

      {/* Helper Text */}
      <p
        style={{
          marginTop: "20px",
          fontSize: "13px",
          color: "#94a3b8",
          textAlign: "center",
        }}
      >
        <i className="bi bi-info-circle me-1"></i>
        Use the filters above to get started
      </p>
    </div>
  );
}

export default InitialPrompt;
